import './style.css';

const fieldsRE = /\{([a-z][a-z_]+)\}/g;

window.DatoCmsPlugin.init((plugin) => {
  plugin.startAutoResizer();

  const runCondition = (condition) => {
    console.log(`runCondition ${condition}`);
    const { getFieldValue } = plugin;
    const evalString = condition.replace(fieldsRE, (match, p1) => JSON.stringify(getFieldValue(p1)));
    console.log(`evalString ${evalString}`);
    // eslint-disable-next-line no-eval
    return !!eval(evalString);
  };

  const { fieldPath } = plugin;
  const { condition } = plugin.parameters.instance;

  plugin.toggleField(fieldPath, runCondition(condition));

  condition.match(fieldsRE, (match, p1) => {
    plugin.addFieldChangeListener(p1, () => {
      plugin.toggleField(fieldPath, this.runCondition(condition));
    });
  });
});
